import { Collection } from '@/state/Collection';
import { _TIPS } from "@/state";
import { _TENANT } from "@/state";
import { ModelDefaults } from "@/state/ModelDefaults";

import { TipsRoutes } from '@/repository/resources';
const { GetAllTips, GetTip, CreateTip, ReplicateTip, UpdateTip, DeleteTip } = TipsRoutes;

// Export this module
export default {
    namespaced: true,
    state: {
        all: Collection.stateDefaults(),
        _all: new Collection({ statePath: 'tips.all' })
    },
    actions: {

        async all({ commit }) {
            try {
                let res = await GetAllTips({ listing: true });
                return res.data || []
            }
            catch (error) {
                console.error('Tips could not be listed.', error);
                throw error;
            }
        },

        async index({ commit }, args) {
            try {
                let { page, per_page } = Object.assign({}, args)
                let res = await GetAllTips({ page, per_page });
                commit('SET_TIPS_LIST', res.data);
            }
            catch (error) {
                console.error('Tips could not be indexed.', error);
                throw error;
            }
        },

        async indexNextPage({ commit }) {
            try {
                if (_TIPS().pagination.isLastPage()) {
                    return;
                }
                let res = await GetAllTips({ page: _TIPS().pagination.nextPage() })
                commit('APPEND_MULTIPLE_TIPS_TO_LIST', res.data);
            }
            catch (error) {
                console.error('Next page of tips could not be indexed.', error);
                throw error;
            }
        },

        async show({ }, { id }) {
            try {
                let res = await GetTip({ tip: id });
                return res.data
            }
            catch (error) {
                console.error('Tip could not be shown.', error);
                throw error;
            }
        },

        async createOrUpdate({ commit }, { tip, replicate = false }) {
            if (_TENANT().blocked_apps.includes('tips')) return;
            try {
                let res = {}
                if (tip.id && !replicate) {
                    res = await UpdateTip({ tip });
                    commit('UPDATE_TIP', res.data)
                }
                else if (tip.id && replicate) {
                    res = await ReplicateTip({ tip });
                    commit('APPEND_SINGLE_TIP_TO_LIST', res.data)
                }
                else if (!tip.id) {
                    res = await CreateTip({ tip });
                    commit('APPEND_SINGLE_TIP_TO_LIST', res.data)
                }
                return res
            }
            catch (error) {
                console.error('Tip could not be created/updated.', error);
                throw error;
            }
        },

        async delete({ commit }, { tip }) {
            if (_TENANT().blocked_apps.includes('tips')) return;
            try {
                let res = await DeleteTip({ tip });
                if (res.status !== 204) {
                    throw 'Problem occurred when deleting tip.';
                }
                commit('DELETE_TIP', tip)
                return true;
            }
            catch (error) {
                console.error('Tip could not be deleted.', error);
                throw error;
            }
        },

        async showEmpty({ }) {
            if (_TENANT().blocked_apps.includes('tips')) return;
            return await ModelDefaults.Tip()
        }

    },
    mutations: {
        SET_TIPS_LIST(state, data) {
            state._all.items.set(data).commitToState()
        },
        APPEND_MULTIPLE_TIPS_TO_LIST(state, objs) {
            state._all.items.appends(objs).commitToState();
        },
        APPEND_SINGLE_TIP_TO_LIST(state, obj) {
            state._all.items.append(obj).commitToState();
        },
        UPDATE_TIP(state, obj) {
            state._all.items.updateItem(obj).commitToState();
        },
        DELETE_TIP(state, obj) {
            state._all.items.deleteItem(obj).commitToState();
        },

    }
}